// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Zji0","error":"Textarea_error__-2vCh","readonly":"Textarea_readonly__1LFzd","disabled":"Textarea_disabled__2g3j_"};